import { ArticleAction, ArticleActionTypes } from "../types/actions";
import { Article } from "../types/article";

const initialState: Article[] = [];

const articlesReducer = (
    state = initialState,
    action: ArticleActionTypes
): Article[] => {
    switch (action.type) {
        case ArticleAction.SET_ARTICLES:
            return action.articles;
        default:
            return state;
    }
};

export default articlesReducer;
